// components/SideDrawerMenu.jsx
import React, { useEffect, useRef } from "react";

import KunGif from "../assets/Kun_basketball.gif";

import "./SideDrawerMenu.css";

import { useNavigate } from "react-router-dom";

const SideDrawerMenu = ({ open, onClose }) => {
  const buttonsRef = useRef([]);

  useEffect(() => {
    const buttons = document.querySelectorAll(".btn");
    buttonsRef.current = buttons;

    const setupButtonAnimation = (button) => {
      let text = button.textContent;
      button.innerHTML = "";

      for (let char of text) {
        let span = document.createElement("span");
        span.textContent = char === " " ? "\u00A0" : char;
        button.appendChild(span);
      }

      let spans = button.querySelectorAll("span");

      const addHoverClass = () => {
        button.classList.add("touch-active");
        spans.forEach((span, index) => {
          setTimeout(() => {
            span.classList.add("hover");
          }, index * 50);
        });
      };

      const removeHoverClass = () => {
        button.classList.remove("touch-active");
        spans.forEach((span, index) => {
          setTimeout(() => {
            span.classList.remove("hover");
          }, index * 50);
        });
      };

      // 鼠标事件
      button.addEventListener("mouseenter", addHoverClass);
      button.addEventListener("mouseleave", removeHoverClass);

      // 触摸事件
      button.addEventListener("touchstart", () => {
        addHoverClass();
      });
      button.addEventListener("touchend", () => {
        removeHoverClass();
      });
    };

    buttons.forEach(setupButtonAnimation);

    // 清理函数
    return () => {
      buttons.forEach((button) => {
        button.removeEventListener("mouseenter", () => {});
        button.removeEventListener("mouseleave", () => {});
      });
    };
  }, []);

  const navigate = useNavigate();

  const handleDownloadClick = () => {
    // 下载简历
    const link = document.createElement("a");
    link.href = "/Juanyan Zhu_Frontend_CV_v3.pdf";
    link.download = "Edison_Zhu_Resume.pdf";
    link.click();
  };

  return (
    <>
      {/* 背景遮罩 */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center max-w-[75%]"
          onClick={onClose}
        >
          <img
            src={KunGif}
            alt="KunGif"
            onClick={(e) => e.stopPropagation()} // 可选：防止点击图片关闭菜单
            className="w-[100%] "
          />
        </div>
      )}

      {/* 抽屉面板 */}
      <div
        className={`fixed top-0 right-0 h-full w-[100%] md:w-[90%] lg:w-[25%] bg-orange-100 dark:bg-neutral-950 text-black dark:text-white shadow-lg z-50 transition-transform duration-500 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col mt-[100px] w-full mx-auto gap-4">
          <div className="">
            <button
              onClick={() => navigate("/")}
              className="btn w-[75%] block mx-auto"
              style={{ "--clr": "#007bff" }}
            >
              <div className="">
                <div className="flex items-center gap-2">
                  <p>Home</p>
                </div>
              </div>
            </button>
          </div>

          <div>
            <button
              onClick={() => navigate("/projects")}
              className="btn block mx-auto w-[75%]"
              style={{ "--clr": "#ff0055" }}
            >
              <div>
                <div className="flex items-center gap-2">
                  <p>Projects</p>
                </div>
              </div>
            </button>
          </div>

          <div>
            <button
              onClick={() => navigate("/contact")}
              className="btn block  mx-auto w-[75%]"
              style={{ "--clr": "#b731e5" }}
            >
              <div>
                <div className="flex items-center gap-2">
                  <p>Contact</p>
                </div>
              </div>
            </button>
          </div>

          <div>
            <button
              onClick={() => handleDownloadClick()}
              className="btn block  mx-auto w-[75%]"
              style={{ "--clr": "#2dccb9" }}
            >
              <div>
                <p>Resume</p>
              </div>
            </button>
          </div>
        </div>
        <div>
          <p></p>
        </div>
      </div>
    </>
  );
};

export default SideDrawerMenu;
